// Header.jsx
import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { useNavigate } from "react-router-dom";
import { smoothScrollToId } from "../../utils/helper.js";
import { IoClose } from "react-icons/io5";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";
import styles from "./Header.module.css";
export const logo = "/assets/logo/logo.png";

export const sakuraIcon = "/assets/icons/sakura.png";
export const phone = "0351 30958928";
export const email = "info.giri.restaurants@gmail.com";
export const address = "Kesselsdorfer Str. 37, 01159 Dresden";
export const hours = "Mo–So: 11:00–15:00 / 17:00–22:00";
export const googleMapsLink = "https://maps.app.goo.gl/f9URKg8KuUksUqwe6";
export const onlineLink = "https://giri-restaurant-dresden.order.dish.co/menus";
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  const topBarRef = useRef(null);
  const headerRef = useRef(null);
  const logoRef = useRef(null);
  const hamburgerRef = useRef(null);
  const menuRef = useRef(null);
  const navLinksRef = useRef([]);
  const sakuraRef = useRef([]);
  const infoItemsRef = useRef([]);
  const contentRef = useRef(null);
  // Scroll detection
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 80;
      setIsScrolled(scrolled);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Animation khi load

  useEffect(() => {
    gsap.fromTo(
      [logoRef.current, hamburgerRef.current],
      { y: -50, opacity: 0 },
      { y: 0, opacity: 1, duration: 1.4, stagger: 0.2, ease: "power3.out" },
    );
    const sakuras = sakuraRef.current;

    sakuras.forEach((petal, i) => {
      if (!petal) return;

      const startX = gsap.utils.random(-200, window.innerWidth + 200);
      const endX = startX + gsap.utils.random(-600, 600);
      const delay = gsap.utils.random(0, 20);
      const duration = gsap.utils.random(15, 30);
      const scale = gsap.utils.random(0.5, 1.2);

      // gsap.set(petal, {
      //     x: startX,
      //     y: -150,
      //     rotation: gsap.utils.random(-360, 360),
      //     scale,
      //     opacity: gsap.utils.random(0.7, 1),
      // });
      gsap.to(petal, {
        y: "120vh",
        x: endX,
        scale: scale,
        rotation: gsap.utils.random(-900, 900),
        duration: duration,
        repeat: -1,
        ease: "none",
        delay: delay,
      });
    });

    // Responsive – reset khi resize
  }, []);

  // Menu animation
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
      gsap.to(menuRef.current, {
        x: "0%",
        duration: 1.2,
        ease: "power4.inOut",
      });
      gsap.to(navLinksRef.current, {
        opacity: 1,
        x: 0,
        stagger: 0.1,
        delay: 0.6,
      });
    } else {
      document.body.style.overflow = "auto";
      gsap.to(navLinksRef.current, { opacity: 0, x: 100, duration: 0.4 });
      gsap.to(menuRef.current, {
        x: "100%",
        duration: 1,
        ease: "power4.inOut",
      });
    }
  }, [menuOpen]);

  const menuItems = [
    { label: "Startseite", to: "/home" },
    { label: "Über uns", to: "#about-us", scroll: true },
    { label: "Tisch reservieren", to: "/tisch-reservieren" },
    { label: "ONLINE BESTELLEN", to: "", href: onlineLink },
    { label: "Speisekarte", to: "/speisekarte" },
    { label: "Kontakt", to: "/kontakt" },
  ];

  return (
    <>
      {/* Thanh thông tin khi ở top */}
      <div
        ref={topBarRef}
        className={`${styles.topBar} ${isScrolled ? styles.hidden : styles.visible}`}
      >
        <div className={styles.topInfo}>
          <div className={styles.infoGroup}>
            <div className={styles.infoItem}>
              <FaMapMarkerAlt />
              <a
                href={googleMapsLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {address}
              </a>
            </div>
            <div className={styles.infoItem}>
              <FaPhoneAlt />
              <span>{phone}</span>
            </div>
          </div>
          <div className={styles.infoGroup}>
            <div className={styles.infoItem}>
              <FaEnvelope />
              <a href={`mailto:${email}`}>{email}</a>
            </div>
            <div className={styles.infoItem}>
              <FaClock />
              <span>{hours}</span>
            </div>
          </div>
        </div>
      </div>
      {/* Main Header */}
      <header
        ref={headerRef}
        className={`${styles.header} ${isScrolled ? styles.scrolled : styles.atTop}`}
      >
        <div className={styles.inner}>
          <div
            className={styles.logo}
            ref={logoRef}
            onClick={() => {
              navigate("/home");
              window.scrollTo(0, 0);
            }}
          >
            <img src="/assets/logo/logo.png" alt="GIRI" />
            <div className={styles.logoText}>
              <span className={styles.brand}>GIRI</span>
              <span className={styles.suffix}> Restaurant</span>
              <small className={styles.tagline}>Asian Fusion Cuisine</small>
            </div>
          </div>

          <div
            ref={hamburgerRef}
            className={`${styles.hamburger} ${menuOpen ? styles.active : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {/* Fullscreen Menu – Đã fix hoàn hảo */}
      <div ref={menuRef} className={styles.fullMenu}>
        {/* Sakura rơi nhẹ */}
        {[...Array(18)].map((_, i) => (
          <div
            key={i}
            ref={(el) => (sakuraRef.current[i] = el)}
            className={styles.sakura}
          >
            <img src={sakuraIcon} height={"50px"} alt="" />
          </div>
        ))}

        <IoClose
          className={styles.closeBtn}
          onClick={() => setMenuOpen(false)}
        />

        {/* Main Navigation */}
        <nav className={styles.nav}>
          {menuItems.map((item, i) => (
            <a
              key={i}
              ref={(el) => (navLinksRef.current[i] = el)}
              className={styles.navLink}
              onClick={() => {
                if (item?.href) {
                  if (item.href === "#") {
                    alert("Update folgt in Kürze");
                  } else {
                    window.location.href = item.href;
                  }
                } else {
                  if (item.scroll) {
                    smoothScrollToId(
                      item.to.replace("#", ""),
                      "start",
                      "nearest",
                      navigate,
                    );
                  } else {
                    window.scrollTo(0, 0);
                    navigate(item.to);
                  }

                  setMenuOpen(false);
                }
              }}
            >
              {item.label}
            </a>
          ))}
        </nav>
        <div ref={contentRef} className={styles.container}>
          {/* Brand Section */}
          <div className={styles.brandIdentity}>
            <div ref={logoRef} className={styles.brandLogo}>
              <img src={logo} alt="GIRI Logo" />
              <div className={styles.glowEffect}></div>
            </div>
            <p className={styles.slogan}>Authentic Asian Fusion Cuisine</p>
            <div className={styles.separator}></div>
          </div>

          {/* Contact Grid */}
          <div className={styles.contactGrid}>
            <div
              ref={(el) => (infoItemsRef.current[0] = el)}
              className={styles.contactCard}
            >
              <div className={styles.iconBox}>
                <FaMapMarkerAlt className={styles.cardIcon} />
              </div>
              <h4>Standort</h4>
              <a
                href={googleMapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.actionLink}
              >
                {address}
              </a>
            </div>

            <div
              ref={(el) => (infoItemsRef.current[1] = el)}
              className={styles.contactCard}
            >
              <div className={styles.iconBox}>
                <FaClock className={styles.cardIcon} />
              </div>
              <h4>Öffnungszeiten</h4>
              <div className={styles.actionLink}>{hours}</div>
              <div className={styles.subText}>Küchenschluss: 21:30 Uhr</div>
            </div>

            <div
              ref={(el) => (infoItemsRef.current[2] = el)}
              className={styles.contactCard}
            >
              <div className={styles.iconBox}>
                <FaPhoneAlt className={styles.cardIcon} />
              </div>
              <h4>Kontakt</h4>
              <a href={`tel:${phone}`} className={styles.actionLink}>
                {phone}
              </a>
              <a href={`mailto:${email}`} className={styles.actionLink}>
                {email}
              </a>
            </div>

                      </div>
        </div>

        {/* Footer slogan */}
        <div className={styles.menuFooter}>
          <p className={styles.japanese}>Ein Moment tiefen Geschmacks</p>
          <p className={styles.english}>A moment of deep flavor for you</p>
        </div>
      </div>
    </>
  );
};

export default Header;
